import { IHotelEnquiry } from "../../types/flights";
import enquiryscss from "../../../sass/enquiry-list/Enquiry.module.scss";

export const EDHotelSub: React.FC<{
  hotelEnquiryData: IHotelEnquiry | undefined;
}> = (props) => {
  return (
    <>
      {props.hotelEnquiryData ? (
        <div className={enquiryscss.segmentContainer}>
          <h6 className={enquiryscss.enquiryDetailHeading}> Hotel Details: </h6>
          <div className={`${enquiryscss.sCrmHotelItem} shadow-sm`}>
            <div className="row align-items-center">
              <div className="col-lg-2 col-12">
                <div className={enquiryscss.detailsSubItem}>
                  City Name: <br />{" "}
                  <span> {props.hotelEnquiryData?.city} </span>
                </div>
              </div>
              {props.hotelEnquiryData.hotelName && (
                <div className="col-lg-2 col-md-6 col-12">
                  <div className={enquiryscss.detailsSubItem}>
                    Hotel Name: <br />{" "}
                    <span> {props.hotelEnquiryData?.hotelName} </span>
                  </div>
                </div>
              )}
              <div className="col-lg-2 col-md-3 col-6">
                <div className={enquiryscss.detailsSubItem}>
                  Checkin:
                  {props.hotelEnquiryData.isFlexible && (
                    <span
                      className={`${enquiryscss.flexible} badge border rounded-pill`}
                    >
                      flexible
                    </span>
                  )}
                  <br />{" "}
                  <span>{props.hotelEnquiryData?.checkin?.toString()}</span>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <div className={enquiryscss.detailsSubItem}>
                  Checkout:
                  {props.hotelEnquiryData.isFlexible && (
                    <span
                      className={`${enquiryscss.flexible} badge border rounded-pill`}
                    >
                      flexible
                    </span>
                  )}
                  <br />{" "}
                  <span>{props.hotelEnquiryData?.checkout?.toString()}</span>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <div className={enquiryscss.detailsSubItem}>
                  Rooms: <br /> <span> {props.hotelEnquiryData?.rooms} </span>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-6">
                <div className={enquiryscss.detailsSubItem}>
                  Hotel Category: <br />{" "}
                  <span> {props.hotelEnquiryData?.category} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );

  // <div>Hotel - {props.hotelEnquiryData?.checkin?.toString()}</div>;
};
